import {
  getBlocks,
  createBlock,
  updateBlock,
  deleteBlock,
  deleteBlocks,
  duplicateBlock,
  updatePreviewUrl,
  updateApiName,
  updateSlug,
  reviveBlock,
} from './crud'
import { reorderBlocks } from './reorder'
import { toggleMakeComponent } from './component'
import { changeBlockType } from './change'
import { createAndReferenceBlock } from './reference'
import {
  changeListTemplate,
  createListView,
  resetListTemplate,
  clearListCells,
  createColumnAndAddToColumnMetadata,
  deleteListView,
  updateListView,
  createListChildrenFromFileNames,
  setListChildrenAsUploadingFiles,
} from './list'
import { selectOptionOp } from './select'
import { pasteBlock } from './paste'
import { blockBatchMutations } from './batch'

export const blockMutators = {
  // crud
  getBlocks,
  createBlock,
  createAndReferenceBlock,
  updateBlock,
  deleteBlock,
  deleteBlocks,
  clearListCells,
  createColumnAndAddToColumnMetadata,
  createListChildrenFromFileNames,
  setListChildrenAsUploadingFiles,
  duplicateBlock,
  pasteBlock,
  updatePreviewUrl,
  updateApiName,
  updateSlug,
  // reorder
  reorderBlocks,
  // component
  toggleMakeComponent,
  // comment
  changeBlockType,
  // List
  changeListTemplate,
  resetListTemplate,
  createListView,
  deleteListView,
  updateListView,
  // Select
  selectOptionOp,
  // Undo/redo
  blockBatchMutations,
  reviveBlock,
}
